import { render, staticRenderFns } from "./PendingTransmissionsPage.vue?vue&type=template&id=031e920c&scoped=true"
import script from "./PendingTransmissionsPage.vue?vue&type=script&lang=js"
export * from "./PendingTransmissionsPage.vue?vue&type=script&lang=js"
import style0 from "./PendingTransmissionsPage.vue?vue&type=style&index=0&id=031e920c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031e920c",
  null
  
)

export default component.exports